import { render, staticRenderFns } from "./EqifyCrudComponent.vue?vue&type=template&id=7ecf1a2a"
import script from "./EqifyCrudComponent.vue?vue&type=script&lang=ts"
export * from "./EqifyCrudComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports